import { Tabs } from "antd";
import BokingHistory from "./BokingHistory";
import PreviousHistory from "./PreviousHistory";
import Sannot from "./Sannot";
import {AppStore} from "../useAppPullState";
import ErrorBoundary from "./ErrorBoundary";
const TabComponent = () => {
    const user = AppStore.useState(s => s.user);
    return (
        <Tabs
            defaultActiveKey='1'
            style={{ width: "100%", height: "100%" }}
            centered
            items={new Array(2).fill(null).map((_, i) => {
                const id = String(i + 1);
                return {
                    label: id == 1 ? `Käytetyt pelioikeudet` :  "Varaukset tänään",
                    key: id,
                    children:
                        id == 1 ? (
                            <div style={{ padding: 5, background: "#eef0f4", borderRadius: 5 }}>
                                <ErrorBoundary>
                                    <BokingHistory userAuth={user} socket={{}} />
                                </ErrorBoundary>

                            </div>
                        ) : (
                            <div style={{ padding: 5, background: "#eef0f4", borderRadius: 5 }}>
                                <PreviousHistory userAuth={user} socket={{}} />
                            </div>
                        ),
                };
            })}
        />
    )
};
export default TabComponent;
